// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sD","ribbon":"sE","title":"sF","genres":"sG"};